import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RestApiService } from "../rest-api.service";

@Injectable({ providedIn: 'root' })
export class IncidentManagerService {
    private endPoints = {
        uploadIncidentScreenshot: 'IncidentMgmt/UploadIncidentScreenshot',
        createIncident: 'IncidentMgmt/CreateIncident',
    }

    constructor(private restAPIService: RestApiService) {

    }

    public uploadIncidentScreenshot(reqData: any): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.uploadIncidentScreenshot, reqData);
    }
    public createIncident(reqData: any): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.createIncident, reqData);
    }
}